import React from "react";
import GeneralTransactionsTable from "./GeneralTransactionsTable";

/**
 * Transactions component - Manages transaction functionality for legal matters
 * Uses the unified GeneralTransactionsTable component with matter-specific endpoints
 */
const TransactionsTable: React.FC = () => {
  return <GeneralTransactionsTable />;
};

export default TransactionsTable;
